import { Box } from '@components/Box';
import React, { FC } from 'react';
import { StyledTextPairing } from './TextPairingWithIcon.styles';
import { JoykitIcon, JoykitIconVariant } from '@components/JoykitIcon';
import { JoykitColor } from '@components/themes';
import { TextPairingProps } from '@components/TextPairing/TextPairing';

type TextPairingWithIconProps = TextPairingProps & {
  iconName: JoykitIconVariant;
  iconColor: JoykitColor;
};

export const TextPairingWithIcon: FC<TextPairingWithIconProps> = (props) => {
  const { iconName, title, body, iconColor, titleVariant, titleColor, bodyVariant, bodyColor } = props;
  return (
    <Box>
      <JoykitIcon name={iconName} color={iconColor} marginBottom={6} />
      <StyledTextPairing
        title={title}
        titleVariant={titleVariant}
        titleColor={titleColor}
        body={body}
        bodyVariant={bodyVariant}
        bodyColor={bodyColor}
      />
    </Box>
  );
};
